import React from 'react';

/**
 * Standardized layout wrapper for all dashboard pages
 * Ensures consistent spacing, typography, and structure
 */
const DashboardPageLayout = ({ 
  title, 
  subtitle, 
  actions,
  children 
}) => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      {(title || subtitle || actions) && (
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
          <div className="flex-1 space-y-1">
            {title && (
              <h1 className="text-3xl font-bold text-gray-900">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-base text-gray-600">
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex flex-col md:flex-row items-stretch md:items-center gap-2 flex-shrink-0">
              {actions}
            </div>
          )}
        </div>
      )}
      
      {/* Page Content */}
      <div>
        {children}
      </div>
    </div>
  );
};

export default DashboardPageLayout;
